// Web mock for react-native-compressor using Canvas API

function compressImage(uri: string, quality: number = 0.8): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(uri);
        return;
      }
      ctx.drawImage(img, 0, 0);
      const compressed = canvas.toDataURL('image/jpeg', quality);
      resolve(compressed);
    };
    img.onerror = () => resolve(uri);
    img.src = uri;
  });
}

export const Image = {
  compress: async (
    uri: string,
    options?: { compressionMethod?: string; quality?: number; maxWidth?: number; maxHeight?: number }
  ): Promise<string> => {
    const quality = options?.quality ?? 0.8;
    return compressImage(uri, quality);
  },
};

export const Video = {
  compress: async (uri: string, _options?: any): Promise<string> => {
    console.warn('[Compressor Web] Video compression not supported on web');
    return uri;
  },
};

export const Audio = {
  compress: async (uri: string, _options?: any): Promise<string> => {
    console.warn('[Compressor Web] Audio compression not supported on web');
    return uri;
  },
};

export default { Image, Video, Audio };
